<template>
  <div>
    <Transition>
    <b-card v-if="waiting"
            overlay
            :img-src="images.instructionImage"
            img-alt="MRZ SEITE NACH UNTEN"
            bg-variant="secondary"
    >
    </b-card>
    <b-card v-else
            :border-variant="(playerBlocked) ? 'danger' : 'success'"
            :header-bg-variant="(playerBlocked) ? 'danger' : 'success'"
            header-text-variant="white"
            bg-variant="secondary"
            text-variant="white"
            align="center">
      <b-card-body class="pb-0">
        <b-card-title>
          <!--<h1 v-if="playerBlocked" class="text-uppercase text-danger ">Kein Zutritt</h1>
          <h1 v-else class="text-uppercase text-success"></h1>-->
        </b-card-title>
        <b-card-text>

          <b-iconstack v-if="playerBlocked" font-scale="15">
            <!--<b-icon stacked  icon="arrow-up" variant="danger" scale="0.75"></b-icon>-->
            <b-icon stacked  icon="dash-circle" variant="danger"></b-icon>
          </b-iconstack>

          <b-iconstack v-else font-scale="15">
            <b-icon stacked  icon="arrow-up" variant="success" scale="0.75"></b-icon>
            <b-icon stacked  icon="circle" variant="success"></b-icon>
          </b-iconstack>

          <p class="mt-1 text-muted"><small>{{status.message}}</small></p>
        </b-card-text>
      </b-card-body>
    </b-card>
    </Transition>

    <b-modal v-model="modals.checkVIZ" align="center" hide-header hide-footer hide-header- body-bg-variant="secondary">
      <h4 class="text-center text-white" id="modal-viz-lock">Probleme mit Ihrem Ausweis!</h4>
      <b-card v-if="waiting"
              overlay
              :img-src="images.serviceImage"
              img-alt="MRZ SEITE NACH UNTEN"
              bg-variant="secondary"
              style="max-width: 10rem;"
      >
      </b-card>
      <h3 class="display-3 text-center text-white">Personal rufen!</h3>
    </b-modal>

    <!--- THIS IS A HIDDEN FORM
    <form  @submit.prevent="checkPlayer"> --->
      <input name="Vorname" v-model.trim="model.SPIELER.V" type="hidden"/>
      <input name="Nachname" v-model.trim="model.SPIELER.N" type="hidden"/>
      <input id="birthday" v-on:blur="updateOnBlur" v-model="model.SPIELER.D" type="hidden">
      <input id="nationality" v-model="hiddenNationField" type="hidden">
      <button name="checkplayer" v-show="false" :disabled="isLoading" @click.prevent="checkPlayer" class="btn btn-primary text-white">
        <b-spinner v-if="isLoading" label="Loading..." small></b-spinner><b-icon v-else label="Loading..." icon="search" small></b-icon></button>
    <!--- </form>
     THIS IS A HIDDEN FORM --->

  </div>
</template>

<script>
  export default {
    name:"check",
    data() {
      return {
        images: {
          instructionImage: require('@/assets/scanner_v3.webp'),
          serviceImage: require('@/assets/warning-circle.svg')
        },
        waiting: true,
        errors: [],
        isLoading: false,
        playerBlocked: false,
        status: {
          type: '',
          message: 'figifhsdhf ijslfhj sfisouhf sfhdnow hfd hkojh  oih wohhofih  hf oihohfff efe',
          showBlockedInfo: false
        },
        hiddenNationField: '999',
        modals: {
          checkVIZ: false,
        },
        model: {
          SPERRGRUND: '',
          SPIELER: {
            id: '',
            V: '', //Vorname
            N: '', //Nachname
            G: '', //Geburtsname
            D: '', //Geburtsdatum
            O: '', //Geburtsort
            A: {    //Anschrift
              P: '',  //Postleitzahl
              W: '', //Wohnort
              S: '', //Straße
              H: '', //Hausnummer
              Z: '', //Adresszusatz
              L: '999', //Ländercode
            }
          },
          INFO: {
            title: '',
            dataprivacy: false,
            approve: false,
            email: ''
          },
          ANLASS: [],
          AUFHEBUNGSGRUND: null,
          FRIST_ENDE: {
            DATUM: '',
            'FORMAT-PATTERN': 'yyyy-MM-dd'
          },
        },
      }
    },
    created(){
      this.getUser(this.$store.getters['authentication/uid']).
      then(data => {
        let activeP = data.profiles.filter(item => item.isActive === true)
        if(activeP.length > 0) {
          this.setProfileSession(activeP[0].id);
        }
      }).catch(error => {
        this.$store.dispatch('alert/error',error)
      })
    },
    methods:{
      updateOnBlur(e) {
        this.model.SPIELER.D = this.$options.filters.formatDateFromFormatToFormat('DD.MM.YYYY', 'YYYY-MM-DD', e.target.value);
        this.key += 1;
      },
      checkPlayer() {
        this.status = {type: '', message: ''};
        this.errors = [];
        this.modals.checkVIZ = false;
        if(this.checkSearchValid()){
          this.$store.dispatch('loading/isLoading')
          this.getPlayer().then(data => {
            const meldungItem = data['MELDUNGSKATALOG-ITEM'] || data;
            const { ART, MELDUNG, SCHLUESSEL } = meldungItem;
            const codeMessage = ` [Code: ${SCHLUESSEL}]`;

            //set data to default in 5 secs
            this.waiting = false;
            setTimeout(() => {
              this.setDefaultData()
            }, 5000);


            const statusConfig = {
              'I': {
                playerBlocked: false,
                status: {
                  type: 'success',
                  message: MELDUNG + codeMessage,
                  showBlockedInfo: true
                }
              },
              'W': {
                playerBlocked: true,
                status: {
                  type: 'danger',
                  message: MELDUNG + codeMessage,
                  showBlockedInfo: true
                },
                sperrInfo: data['SPERRINFO'] || []
              },
              'E': {
                playerBlocked: 'warning',
                status: {
                  type: 'danger',
                  message: 'OASIS meldet:' + MELDUNG + codeMessage,
                  showBlockedInfo: false
                }
              }
            };

            const config = statusConfig[ART] || {
              playerBlocked: false,
              status: {
                type: 'warning',
                message: 'Undefinierte Rückmeldung von OASIS',
                showBlockedInfo: false
              }
            };

            if (SCHLUESSEL === '0052') {
              config.status.type = 'warning'
              config.playerBlocked = 'warning'
            }

            Object.assign(this, config);

            // eslint-disable-next-line no-console
            console.log(`${this.playerBlocked ? 'playerBlocked' : 'playerNotBlocked'}:${this.status.message}`);
            this.$store.dispatch('loading/loadingIsFinished')
            this.waiting = false;
            this.key++;
          }).catch( error => {
            //this.status = {type: 'warning', message: error, showBlockedInfo: false};
            this.$store.dispatch('alert/error', typeof error['error'] !== 'undefined' ? error['error'] : error);
            this.$store.dispatch('loading/loadingIsFinished')
            this.key++; });

        } else {
          this.status = {type: 'warning', message: 'Bitte geben Sie zunächst die Vorname, Nachname und Geburtsdatum an.', showBlockedInfo: false};
          // eslint-disable-next-line no-console
          console.log("warning:"+this.status.message);
        }
      },
      getPlayer() {
        return new Promise((resolve, reject) => {
          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          let senddata = {SPIELER: JSON.parse(JSON.stringify(this.model.SPIELER))};
          if (senddata.SPIELER.A.L === '999') delete senddata.SPIELER.A.L;
          const requestOptions = {
            method: 'POST',
            headers: header,
            body: JSON.stringify(senddata)
          };

          let url = '/oasis/check/'+this.$store.getters['authentication/location'];

          fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                if (response.error)
                {
                  reject(response)
                } else {
                  resolve(response);
                }
              }, error => {reject(error)});
        })
      },
      checkSearchValid() {
        const namelength = (this.model.SPIELER.N + this.model.SPIELER.V).length;
        if (this.model.SPIELER.V !== '' &&
            this.model.SPIELER.N !== '' &&
            this.model.SPIELER.D !== '' &&
            ((namelength < 25 || namelength > 30) && namelength !== 39)) {
          return true;
        }

        this.modals.checkVIZ = true;
        setTimeout(() => {
          this.modals.checkVIZ = false;
        }, 5000);

        this.key++;

        return false;
      },
      getUser(id) {
        return new Promise((resolve, reject) => {
          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header,
          };
          fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                    resolve(response)
                  },
                  error => {
                    reject(error)
                  });
        });
      },
      setProfileSession(id) {
        const header = this.authHeader();
        header['Content-Type'] = 'application/json';
        const requestOptions = {
          method: 'GET',
          headers: header,
        };
        return fetch(process.env.VUE_APP_API_SERVER + `/api/currentprofile/set/`+id, requestOptions)
            .then(this.handleResponse)
            .then(data => {
              return data;
            });
      },
      setDefaultData() {
        this.key++;
        //var d = new Date();
        //var year = d.getFullYear();
        //var month = d.getMonth();
        //var day = d.getDate();
        //var c = new Date(year + 1, month, day);
        this.model = {
          SPERRGRUND:'',
          SPIELER:{
            id:'',
            V:'', //Vorname
            N:'', //Nachname
            G:'', //Geburtsname
            D:'', //Geburtsdatum
            O:'', //Geburtsort
            A:{    //Anschrift
              P:'',  //Postleitzahl
              W:'', //Wohnort
              S:'', //Straße
              H:'', //Hausnummer
              Z:'', //Adresszusatz
              L:'999' //Ländercode
            }
          },
          INFO:{
            title:'',
            approve:false,
            dataprivacy:false,
            email:''
          },
          ANLASS:[],
          FRIST_ENDE:{
            DATUM:'',
            'FORMAT-PATTERN':'dd.MM.yyyy'
          }
        };

        this.isLoading = false;
        this.status = {type:'', message:'', showBlockedInfo:false};
        this.modals.checkVIZ = false;
        this.playerBlocked = false;
        this.waiting = true;
        this.errors = [];
      }

    }
    }
</script>

<style scoped>
  .fat-border {
    border: 7px solid;
  }
  /* we will explain what these classes do next! */
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>